import { transition } from "@huub-web/ui/utils/transition";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = style({
  listStyle: "none",
});

export const buttonStyle = recipe({
  base: {
    width: "100%",
    padding: theme.spacings.s,
    borderRadius: theme.borderRadiuses.xs,
    transition: transition("background-color", "color", "opacity"),
    position: "relative",
    backgroundColor: "transparent",
    color: theme.colors.onBackground,
    cursor: "pointer",
    selectors: {
      "&:before": {
        // content: '""',
        // position: "absolute",
        // bottom: 0,
        // left: 0,
        // width: "100%",
        // height: rem(1),
        // backgroundColor: theme.colors.defaultBorder,
        // transition: transition("opacity"),
      },
      "&:hover": {
        backgroundColor: theme.colors.tertiary,
      },
      "&:hover:before": {
        opacity: 0,
      },
    },
  },
  variants: {
    active: {
      true: {
        backgroundColor: theme.colors.tertiary,
        selectors: {
          "&:before": {
            opacity: 0,
          },
        },
      },
    },
    disabled: {
      true: {
        opacity: 0.5,
        cursor: "not-allowed",
        selectors: {
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
});
